import i18n from 'i18n/config';
import { useEffect, useState } from 'react';

import { SelectorOption } from 'types';

import { SingleValue } from 'react-select';
import { translate } from 'hooks/useTranslate';
import aliasOptions from '../constants/aliasOptions';

export const useGetAliasOptions = () => {
  const [aliasOptionsList, setAliasOptionsList] = useState<SelectorOption[]>(
    []
  );
  const [selectedAlias, setSelectedAlias] = useState<string>('');

  const handleChangeAlias = (option: SingleValue<SelectorOption>) => {
    setSelectedAlias(option?.value ?? '');
  };

  useEffect(() => {
    const options: SelectorOption[] = aliasOptions.map((alias: string) => ({
      value: alias,
      label: translate(alias),
    }));

    setAliasOptionsList(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return {
    data: {
      aliasOptions: aliasOptionsList,
      selectedAlias,
    },
    actions: {
      handleChangeAlias,
    },
  };
};
